import { useTranslation } from "react-i18next";
import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@cieda/djayma-ui";
import type { Product } from "@/lib/validation/product";

interface BulkDeactivateModalProps {
  readonly open: boolean;
  readonly onOpenChange: (open: boolean) => void;
  readonly products: readonly Product[];
  readonly onConfirm: () => void;
  readonly isLoading: boolean;
}

export function BulkDeactivateModal({
  open,
  onOpenChange,
  products,
  onConfirm,
  isLoading,
}: BulkDeactivateModalProps) {
  const { t } = useTranslation("admin");
  const preview = products.slice(0, 5);
  const remaining = products.length - preview.length;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {t("products.bulk.confirm_deactivate", { count: products.length })}
          </DialogTitle>
        </DialogHeader>
        <ul className="space-y-1 text-sm text-stone-700">
          {preview.map((p) => (
            <li key={p.id}>{p.name}</li>
          ))}
          {remaining > 0 && (
            <li className="text-stone-400">et {remaining} autre(s)</li>
          )}
        </ul>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Annuler
          </Button>
          <Button onClick={onConfirm} disabled={isLoading}>
            {t("products.bulk.deactivate")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
